// extracted by mini-css-extract-plugin
export var box = "_r-2";
export var checkboxControl = "_r-0";
export var checkboxRow = "_r-a";
export var checked = "_r-3";
export var descriptionSpacer = "_r-c";
export var disabled = "_r-4";
export var icon = "_r-8";
export var input = "_r-1";
export var labelSpacer = "_r-b";
export var large = "_r-7";
export var medium = "_r-6";
export var small = "_r-5";
export var text = "_r-9";